import { useEffect, useState } from "react";
import { generateRandomNumberInRange } from "@/lib/utils";
import { CONTENT_STACK, DEFAULT_LOADER_CONTENT } from "./constants";
import { LoaderContent } from "./type";

export function useLoaderContent(isOpen: boolean) {
  const [content, setContent] = useState<LoaderContent>(DEFAULT_LOADER_CONTENT);

  useEffect(() => {
    if (isOpen) {
      const index = generateRandomNumberInRange(0, CONTENT_STACK.length - 1);
      setContent(CONTENT_STACK[index]);
    }
  }, [isOpen]);

  return content;
}
